import { parse } from 'Plugins/markdown/helpers'

const markItDown = (element, binding) => {
  let html = parse(binding.value)
  element.innerHTML = html
}
export default {
  bind(el, binding) {
    el.classList.add('marked-text')
    markItDown(el, binding)
  },
  componentUpdated(el, binding) {
    markItDown(el, binding)
  },
}
